module.exports = __webpack_public_path__ + "static/fipcunicorn2-1c8bfd1361d5a61b0732281a757ef249.jpeg";